import React from "react";

export const CustomPlaceholder = (props) => {
  const left = props.depth * 24;
  return <div className="tree--praceholder--root" style={{ left }}></div>;
};
